import React from 'react'
import './index.css'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'

const pageSizes = ["10", "25", "50", "100"]

const Pagination = props => {
    const handleSetPage = (e) => props.handleApiCall({ page: e.target.innerText.trim(), pageSize: props.pageSize })

    const handleSetPageSize = (e) => props.handleApiCall({ page: props.page, pageSize: e.target.innerText.trim() })

    const getPages = () => {
        const pages = []
        const pageNumbers = props.numOfPages ? props.numOfPages : 1
        for (let i = 1; i <= pageNumbers; i++) {
            pages.push(
                <MenuItem
                    key={i.toString()}
                    value={i.toString()}
                    primaryText={i.toString()}
                    id="page"
                />
            )
        }
        return pages;
    }

    const getPageSizes = () => (
        pageSizes.map(pageSize => (
            <MenuItem
                key={pageSize}
                value={pageSize}
                primaryText={pageSize}
                id="pageSize"
            />
        ))
    )

    return (
        <div className="pagination">
            <div className="dropdownContainerLeft">
                <h5>Page Number</h5>
                <SelectField
                    name="page"
                    value={props.page}
                    hintText={"Select Page"}
                    hintStyle={{ color: "black", position: "absolute", top: "5px" }}
                    onChange={handleSetPage}
                    iconStyle={{ paddingLeft: "22px", fill: "rgba(0, 0, 0, 0.87)", marginTop: "-7px", marginRight: "3px" }}
                    style={{ borderRadius: "5px", backgroundColor: "#e8e8e8", paddingLeft: "12px", height: "32px", width: "120px" }}
                    labelStyle={{ color: "rgba(0, 0, 0, 0.87)", marginTop: "-7px" }}
                    underlineStyle={{ border: "none" }}
                >
                    {getPages()}
                </SelectField>
            </div>
            <div className="dropdownContainerRight">
                <h5>Page Size</h5>
                <SelectField
                    name="pageSize"
                    value={props.pageSize}
                    hintText={"Select Page Size"}
                    hintStyle={{ color: "black", position: "absolute", top: "5px" }}
                    onChange={handleSetPageSize}
                    iconStyle={{ paddingLeft: "22px", fill: "rgba(0, 0, 0, 0.87)", marginTop: "-7px", marginRight: "3px" }}
                    style={{ borderRadius: "5px", backgroundColor: "#e8e8e8", paddingLeft: "12px", height: "32px", width: "120px" }}
                    labelStyle={{ color: "rgba(0, 0, 0, 0.87)", marginTop: "-7px" }}
                    underlineStyle={{ border: "none" }}
                >
                    {getPageSizes()}
                </SelectField>
            </div>
        </div>
    )
}

export default Pagination
